/**
 * Image upload constants shared across all apps
 */

/** Maximum number of images allowed per entity (spot, expense, etc.) */
export const MAX_IMAGES_PER_ENTITY = 5;

/** Maximum file size in bytes (10MB) */
export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;

/** Maximum image dimensions after resize */
export const MAX_IMAGE_WIDTH = 1920;
export const MAX_IMAGE_HEIGHT = 1920;

/** JPEG quality for resized images (0-1) */
export const IMAGE_QUALITY = 0.85;
